import { mixpanelTrack } from '@/providers/Mixpanel';
import { useEffect } from 'react';

type Props = {
  type: string;
  id: string | null;
};

const MixPanelTracker: React.FC<Props> = ({ type, id }) => {
  useEffect(() => {
    mixpanelTrack(`Viewed Pane: ${type}`, { id });
  }, [type, id]);

  return null;
};

export default MixPanelTracker;